module.exports = __webpack_public_path__ + "img/logo-placeholder.9c0b8d48.png";